import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useQuery } from '@tanstack/react-query';
import getFetchCartTranslationsOptions from './get-options';
import getWebShellClientLocale from "../../../../utils/get-webshellclient-locale";
var useI18nString = function useI18nString() {
  var _data$resolvedStringK;
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    primaryValue = _ref.primaryValue,
    stringKey = _ref.stringKey,
    icuTokens = _ref.icuTokens,
    countryOverrides = _ref.countryOverrides;
  var _getWebShellClientLoc = getWebShellClientLocale(),
    country = _getWebShellClientLoc.country,
    language = _getWebShellClientLoc.hreflang;
  var _useQuery = useQuery(getFetchCartTranslationsOptions({
      language: language
    })),
    data = _useQuery.data,
    isLoading = _useQuery.isLoading;
  if (isLoading) return '';
  var countryOverrideKey = countryOverrides === null || countryOverrides === void 0 ? void 0 : countryOverrides[country === null || country === void 0 ? void 0 : country.toLowerCase()];
  var resolvedStringKey = countryOverrideKey || stringKey;
  var finalString = (_data$resolvedStringK = data[resolvedStringKey]) === null || _data$resolvedStringK === void 0 ? void 0 : _data$resolvedStringK.value;

  // If translation not found, use primaryValue
  if (!finalString) {
    finalString = primaryValue === '' ? '' : "\u226A\u226A".concat(primaryValue, "\u226B\u226B");
  }

  // Replace icuTokens placeholders if provided
  if (finalString && icuTokens) {
    Object.entries(icuTokens).forEach(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
        key = _ref3[0],
        value = _ref3[1];
      // Replace {key} with value in the string
      finalString = finalString.replace("{".concat(key, "}"), value || '');
    });
  }
  return finalString;
};
export default useI18nString;